import { useState, useCallback, useEffect } from "react";
import {
  getInvitationByToken,
  acceptInvitation,
  acceptAgencyInvitation,
  type InvitationAcceptInfo,
} from "../api/pendingInvitations";

export function useAcceptInvitation(token: string | undefined) {
  const [invitation, setInvitation] = useState<InvitationAcceptInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    if (!token) {
      setError("Invalid invitation link.");
      setLoading(false);
      return;
    }
    getInvitationByToken(token).then((result) => {
      setLoading(false);
      if ("error" in result) {
        setError(result.error);
      } else {
        setInvitation(result);
      }
    });
  }, [token]);

  const accept = useCallback(async () => {
    if (!token || !invitation) return null;
    setAccepting(true);

    // Agency client invitation → public accept endpoint (no auth)
    if (invitation.role === "agency_client") {
      const result = await acceptAgencyInvitation(token);
      setAccepting(false);
      if ("error" in result) {
        setError(result.error);
      }
      return result;
    }

    // Standard member invitation
    const result = await acceptInvitation(token);
    setAccepting(false);
    if ("error" in result) {
      setError(result.error);
    }
    return result;
  }, [token, invitation]);

  const isAgencyInvite = invitation?.role === "agency_client";

  return { invitation, loading, error, accepting, accept, isAgencyInvite };
}
